import * as React from "react";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  CircularProgress,
  Button,
  Backdrop,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography
} from "@mui/material";
import { Form, Formik } from "formik";
import RequiredAsterisk from "../components/RequiredAsterisk";
import * as Yup from "yup";
import SendIcon from "@mui/icons-material/Send";
import { Col, Row } from "react-bootstrap";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";

dayjs.extend(utc);
dayjs.extend(timezone);

const schemaCheckOutForm2 = Yup.object({
  trading_stc: Yup.string().required('Are you trading is required.'),
});

const CheckOutForm2 = ({ data, setData, next, prev }) => {
  const [showSTCModal, setShowSTCModal] = React.useState(false);

  const handleSubmit = (values) => {
    next(values);
  }

  const handleSTCChange = (e, handleChange) => {
    if (e.target.value === '1') {
      setShowSTCModal(true);
    } else {
      setData(prev => ({ ...prev, trading_stc: e.target.value }));
      handleChange(e);
    }
  };

  const handleSTCConfirm = (handleChange) => {
    setData(prev => ({ ...prev, trading_stc: '1' }));
    handleChange({
      target: {
        value: '1',
        name: 'trading_stc'
      }
    });
    setShowSTCModal(false);
  };

  return (
    <Formik
      initialValues={data}
      onSubmit={handleSubmit}
      validationSchema={schemaCheckOutForm2}
    >

      {({
        values,
        handleChange,
        handleSubmit,
        errors,
        isSubmitting
      }) => {

        return (
          <>
            <Form onSubmit={handleSubmit}>

              <div className="mb-4 p-4 border rounded">

                <FormControl fullWidth className="mb-5">
                  <FormLabel id="customer-order-no-label" className="fw-bold mb-3">Your Purchase Order/Customer Reference (optional)</FormLabel>
                  <TextField id="customer-order-no" label="Purchase Order/Customer Reference" name="customer_order_no"
                    value={values.customer_order_no}
                    onChange={handleChange}
                  />
                </FormControl>

              </div>

              <div className="mb-4 p-4 border rounded">
                <FormControl fullWidth className="mb-4">
                  <FormLabel id="trading-stc" className="fw-bold">Are you trading STC's with
                    iStore? <RequiredAsterisk /></FormLabel>
                  <RadioGroup aria-labelledby="trading-stc" name="trading_stc"
                    value={data.trading_stc}
                    onChange={e => handleSTCChange(e, handleChange)}
                  >
                    <FormControlLabel value="0" control={<Radio value="0" />} label="NO - NOT TRADING STC's" />
                    <FormControlLabel value="1" control={<Radio value="1" />} label="YES - TRADING STC's With iStore" />
                  </RadioGroup>
                </FormControl>

              </div>

              <Row style={{ marginBottom: '40px' }}>
                <Col xs={3}>
                  <Button variant="contained" type="button" size="large"
                    onClick={() => prev(values)}>
                    Prev
                  </Button>
                </Col>
                <Col xs={9} className="text-end">

                  <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={isSubmitting}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>

                  <Button disabled={isSubmitting} size="large" variant="contained"
                    type="submit"
                    endIcon={data.trading_stc === '0' && <SendIcon />}
                  >
                    {data.trading_stc === '0' ? 'Place Order' : 'Next'}
                  </Button>

                </Col>
              </Row>

            </Form>

            {/* STC Confirmation Modal */}
            <Dialog
              open={showSTCModal}
              onClose={() => setShowSTCModal(false)}
              maxWidth="sm"
              fullWidth
              PaperProps={{
                sx: {
                  borderRadius: '0.375rem',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                  border: '1px solid #dee2e6'
                }
              }}
            >
              <DialogTitle
                sx={{
                  background: '#042942',
                  color: '#ffffff',
                  fontWeight: 'bold',
                  fontSize: '1.25rem',
                  padding: '16px 24px',
                  borderBottom: '1px solid #dee2e6'
                }}
              >
                Trading STC Confirmation
              </DialogTitle>
              <DialogContent
                sx={{
                  padding: '24px',
                  backgroundColor: 'rgba(248, 249, 250, 0.8)'
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: '#495057',
                    fontSize: '1rem',
                    lineHeight: '1.5',
                    paddingTop: '20px',
                  }}
                >
                  Pending - To be verified by Admin
                </Typography>
              </DialogContent>
              <DialogActions
                sx={{
                  padding: '16px 24px',
                  backgroundColor: '#ffffff',
                  borderTop: '1px solid #f1f3f4'
                }}
              >
                <Button
                  onClick={() => handleSTCConfirm(handleChange)}
                  variant="contained"
                  autoFocus
                  sx={{
                    backgroundColor: '#0d6efd',
                    '&:hover': {
                      backgroundColor: '#0056b3'
                    },
                    minHeight: '40px',
                    borderRadius: '0.375rem'
                  }}
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
          </>
        );

      }}
    </Formik>
  );
}

export default CheckOutForm2;